const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE';
const CLEAR_USER_DATA = 'CLEAR_USER_DATA';
const SET_USER_DATA = 'SET_USER_DATA';
const UPDATE_ACCESS_TOKEN = 'UPDATE_ACCESS_TOKEN';

export { UPDATE_USER_ROLE, CLEAR_USER_DATA, SET_USER_DATA, UPDATE_ACCESS_TOKEN };
